import { useEffect } from "react";

const useCustomCursor = () => {
  useEffect(() => {
    const inner = document.querySelector<HTMLDivElement>(".cursor-inner");
    const outer = document.querySelector<HTMLDivElement>(".cursor-outer");

    if (!inner || !outer) return;

    let isHovering = false;

    const onMouseMove = (e: MouseEvent) => {
      if (!isHovering) {
        outer.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      }
      inner.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    };

    const onMouseEnter = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest("a, .cursor-pointer")) {
        inner.classList.add("cursor-hover");
        outer.classList.add("cursor-hover");
        isHovering = true;
      }
    };

    const onMouseLeave = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest("a, .cursor-pointer")) {
        inner.classList.remove("cursor-hover");
        outer.classList.remove("cursor-hover");
        isHovering = false;
      }
    };

    document.addEventListener("mousemove", onMouseMove);
    document.body.addEventListener("mouseover", onMouseEnter);
    document.body.addEventListener("mouseout", onMouseLeave);

    inner.style.visibility = "visible";
    outer.style.visibility = "visible";

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.body.removeEventListener("mouseover", onMouseEnter);
      document.body.removeEventListener("mouseout", onMouseLeave);
    };
  }, []);
};

export default useCustomCursor;
